/*
 * The refund terms that used to sit at the top of the page, kept verbatim
 * but folded into a compact card so the form is the first thing on screen.
 */
const PolicyNote = () => (
  <section className="c4rtn__policy" aria-labelledby="c4rtn-policy-heading">
    <h2 className="c4rtn__policy-title" id="c4rtn-policy-heading">
      Before You Submit
    </h2>

    <ul className="c4rtn__policy-list">
      <li>
        <strong>Damaged or broken items</strong> — claim within 7 days of
        delivery, with clear photo or video evidence.
      </li>
      <li>
        <strong>Non-delivery or misplaced goods</strong> — claim within 10 days
        of the dispatch date.
      </li>
      <li>
        <strong>Change of mind</strong> — the item must be in its original
        condition and returned within 14 days of delivery.
      </li>
      <li>
        <strong>Proof of condition</strong> — clear photos of the affected item
        are required for every claim.
      </li>
      <li>
        <strong>Address changes</strong> — once an order has been dispatched we
        cannot cover delivery issues caused by a changed address.
      </li>
    </ul>

    <p className="c4rtn__policy-text">
      We decide the outcome from the evidence supplied: a{" "}
      <strong>full refund</strong> where the item is defective or unusable, a{" "}
      <strong>partial refund</strong> for minor issues, or a{" "}
      <strong>like-for-like replacement</strong> where one is available. Refunds
      are processed once the returned goods have been received and inspected,
      and always go back to the original payment method.
    </p>
  </section>
);

export default PolicyNote;
